import { createApp, ref } from 'vue';
import App from './App.vue';
import router from './router';
import ModalRoot from '@/plugins/modalPlugin';
import Notifications from '@kyvg/vue3-notification';

import './assets/styles/styles.scss';

import vueSvgInlinePlugin from 'vue-svg-inline-plugin';

import {
    ApiKey,
    AuthKey,
    BroadcastKey,
    DocumentDownloaderKey,
    RouterKey,
    ModalKey,
    PagePropertiesKey,
} from './injection/keys';

import Api from './classes/Api';
import Auth from './classes/Auth';
import Broadcast from '@/classes/Broadcast.ts';

import { PageProperties } from '@/types/page-properties.type.ts';
const $PageProperties = ref<PageProperties>({
    accessDenied: false,
    notFound: false,
});

const $Api = new Api($PageProperties);

import { authEndpoints } from '@/repositories/auth/AuthEndpoints.ts';
$Api.addEndpoints(authEndpoints);

import { cityEndpoints } from '@/repositories/city/CityEndpoints.ts';
$Api.addEndpoints(cityEndpoints);

import { holdingEndpoints } from '@/repositories/holding/HoldingEndpoints.ts';
$Api.addEndpoints(holdingEndpoints);

import { dealerEndpoints } from '@/repositories/dealer/DealerEndpoints.ts';
$Api.addEndpoints(dealerEndpoints);

import { userEndpoints } from '@/repositories/user/UserEndpoints.ts';
$Api.addEndpoints(userEndpoints);

import { modelEndpoints } from '@/repositories/model/ModelEndpoints.ts';
$Api.addEndpoints(modelEndpoints);

import { complectationEndpoints } from '@/repositories/complectation/ComplectationEndpoints.ts';
$Api.addEndpoints(complectationEndpoints);

import { carEndpoints } from '@/repositories/car/CarEndpoints.ts';
$Api.addEndpoints(carEndpoints);

import { auctionEndpoints } from '@/repositories/auction/AuctionEndpoints.ts';
$Api.addEndpoints(auctionEndpoints);

import { reportEndpoints } from '@/repositories/report/ReportEndpoints.ts';
$Api.addEndpoints(reportEndpoints);

import { deliveryPriceEndpoints } from '@/repositories/delivery-price/DeliveryPriceEndpoints.ts';
import DocumentDownloader from '@/classes/DocumentDownloader.ts';
$Api.addEndpoints(deliveryPriceEndpoints);

import { documentEndpoints } from '@/repositories/document/DocumentEndpoints.ts';
$Api.addEndpoints(documentEndpoints);

import { feedbackEndpoints } from '@/repositories/feedback/FeedbackEndpoints.ts';
$Api.addEndpoints(feedbackEndpoints);

import { ModalPlugin } from '@/plugins/modalPlugin';

const $Auth = new Auth($Api);

const $Broadcast = new Broadcast($Api);

const $DocumentDownloader = new DocumentDownloader($Api);

import { createPinia } from 'pinia';
const pinia = createPinia();

import * as Sentry from '@sentry/vue';

const app = createApp(App);

app.provide(ApiKey, $Api);
app.provide(AuthKey, $Auth);
app.provide(BroadcastKey, $Broadcast);
app.provide(RouterKey, router);
app.provide(ModalKey, ModalPlugin);
app.provide(DocumentDownloaderKey, $DocumentDownloader);
app.provide(PagePropertiesKey, $PageProperties);
app.use(ModalRoot);
app.use(router);
app.use(vueSvgInlinePlugin);
app.use(Notifications);
app.use(pinia);

Sentry.init({
    app,
    enabled: !!(import.meta.env['VITE_APP_SENTRY_DSN']),
    dsn: import.meta.env['VITE_APP_SENTRY_DSN'],
    beforeSend: (event) => {
        event.user = {
            ...event.user,
            ...$Auth.getCurrentUserForSentry(),
        };

        return event;
    },
});

app.mount('#app');
